import styled from 'styled-components'
import { Typography } from '../Typography'
import { Config } from '../../../config/index'

const { palette } = Config

export const InputLabel = styled(Typography).attrs({
  as: 'label',
  variant: 7,
  className: 'pb-3 pt-2',
})<any>`
  line-height: 1.3;
  color: ${palette.primary};
  font-weight: 400;
  display: block;

  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'all')};
`

export const Input = styled.input.attrs({
  className: 'p-3',
})`
  margin-top: 0.6rem;
  display: block;
  width: 100%;
  height: 4.4rem;
  border: 0.1rem solid rgba(34, 34, 34, 0.2);
  font-weight: 400;
  font-size: 1.3rem;
  border-radius: 0.4rem;
  outline: none;
  overflow: hidden;
  background-color: ${palette.secondary};
  -webkit-appearance: none;

  &:hover {
    border-color: ${palette.hint};
  }

  &:focus {
    border-color: ${palette.primary};
  }

  &:disabled {
    background: ${palette.disabled};
  }
`

export const TextArea = styled(Input).attrs({
  as: 'textarea',
})`
  min-width: 100%;
  max-width: 100%;
  min-height: 18rem;
`
